import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-15" }, "Subcategorias de serviços", -1)
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Categoria", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione a categoria", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Subcategoria", -1)
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ordem", -1)
const _hoisted_12 = { class: "col-md-2 d-flex gap-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "subcategory-active",
  class: "form-check-label"
}, "Subcategoria ativa", -1)
const _hoisted_17 = {
  key: 0,
  class: "alert alert-danger mt-3 mb-0"
}
const _hoisted_18 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table align-middle mb-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Subcategoria"),
    /*#__PURE__*/_createElementVNode("th", null, "Categoria"),
    /*#__PURE__*/_createElementVNode("th", null, "Ordem"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Editar")
  ])
], -1)
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center text-muted"
}, "Nenhuma subcategoria cadastrada.", -1)
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        class: "row g-3 align-items-end",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.category_id) = $event)),
            class: "form-select",
            required: ""
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategories, (category) => {
              return (_openBlock(), _createElementBlock("option", {
                key: category.id,
                value: category.id
              }, _toDisplayString(category.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.form.category_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
            class: "form-control",
            placeholder: "Ex.: Protocolos faciais",
            required: ""
          }, null, 512), [
            [
              _vModelText,
              _ctx.form.name,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.sort) = $event)),
            type: "number",
            min: "0",
            class: "form-control"
          }, null, 512), [
            [
              _vModelText,
              _ctx.form.sort,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn btn-success flex-grow-1",
            disabled: _ctx.saving
          }, _toDisplayString(_ctx.saving ? 'Salvando...' : (_ctx.editingId ? 'Atualizar' : 'Criar')), 9, _hoisted_13),
          (_ctx.editingId)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-secondary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
              }, "Cancelar"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              id: "subcategory-active",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.active) = $event)),
              type: "checkbox",
              class: "form-check-input"
            }, null, 512), [
              [_vModelCheckbox, _ctx.form.active]
            ]),
            _hoisted_16
          ])
        ])
      ], 32),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("table", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSubcategories, (subcategory) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: subcategory.id
              }, [
                _createElementVNode("td", null, _toDisplayString(subcategory.name), 1),
                _createElementVNode("td", null, _toDisplayString(subcategory.category?.name || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(subcategory.sort ?? '-'), 1),
                _createElementVNode("td", null, _toDisplayString(subcategory.active ? 'Ativa' : 'Inativa'), 1),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary",
                    onClick: ($event: any) => (_ctx.edit(subcategory))
                  }, "Editar", 8, _hoisted_23)
                ])
              ]))
            }), 128)),
            (!_ctx.getSubcategories.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}